/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Scope_LabelInputs */



/**
* | output |
* | --- |
* | "Scope" |
*
* @param {Explorer_Search_Scope_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_scope_label = /** @type {((inputs?: Explorer_Search_Scope_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Scope_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scope")
	if (locale === "de") return /** @type {LocalizedString} */ ("Scope")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scope")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Scope")
	if (locale === "es") return /** @type {LocalizedString} */ ("Scope")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Scope")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Scope")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Scope")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Scope")
	return /** @type {LocalizedString} */ ("Scope")
});